import { useAppApi, usePAppApi, useUAppApi } from 'hooks/useAppApi';
import { Modal, notification } from 'antd';
import React, { createContext, useCallback, useContext } from 'react';
import { debounce } from 'lodash';
// Crear el contexto
const ClientesActionsContext = createContext(null);

// Componente proveedor del contexto
export const ClientesActionsProvider = ({ children }) => {
  const { call: update, isLoading: loadingUpdate } = useUAppApi({
    url: '/clientes',
    mapResults: useCallback((data) => {
      return data;
    }, []),
  });

  const toggleStatus = async (id, active) => {
    await update(
      {
        active: !active,
      },
      `/${id}`
    );
  };

  const callToggle = async (id, active, confirm = false) => {
    return update(
      { preventiva: active },
      `/${id}/preventiva-automatizada`,
      confirm ? { confirm: '1' } : undefined
    );
  };

  // Utiliza debounce para evitar actualizaciones repetidas sin sentido
  const toggleAutoPreven = useCallback(
    debounce(async (id, active) => {
      try {
        await callToggle(id, active, false);
        if (active) {
          notification.success({
            message: 'Mantención preventiva automatizada activada',
          });
        }
      } catch (err) {
        const status = err?.response?.status;
        const data = err?.response?.data;

        if (status === 409 && data?.code === 'SIN_PLAN_PARCIAL') {
          Modal.confirm({
            title: 'Algunos ascensores no tienen plan de mantención',
            content: (
              <div>
                <p>{data.mensaje}</p>
                <p style={{ marginTop: 8, fontWeight: 500 }}>
                  Ascensores sin plan:
                </p>
                <pre
                  style={{
                    background: '#f5f5f5',
                    padding: 8,
                    borderRadius: 4,
                    margin: 0,
                  }}
                >
                  {(data.ascensoresSinPlan || [])
                    .map((a) => `• ${a.nombre}`)
                    .join('\n')}
                </pre>
              </div>
            ),
            okText: 'Activar igual',
            cancelText: 'Cancelar',
            onOk: async () => {
              try {
                await callToggle(id, active, true);
                notification.success({
                  message: 'Mantención preventiva automatizada activada',
                  description: `Solo cubrirá los ${data.conPlan} ascensor(es) con plan.`,
                });
              } catch (retryErr) {
                notification.error({
                  message: 'Error al activar la automatización',
                  description:
                    retryErr?.response?.data?.mensaje ||
                    'Ocurrió un error inesperado.',
                });
              }
            },
          });
          return;
        }

        if (status === 400) {
          notification.error({
            message: 'No se puede activar la automatización',
            description:
              data?.mensaje || 'El cliente no cumple los requisitos.',
            duration: 8,
          });
          return;
        }

        notification.error({
          message: 'Error al actualizar la automatización',
          description:
            data?.mensaje || err?.message || 'Ocurrió un error inesperado.',
        });
      }
    }, 500),
    []
  );
  return (
    <ClientesActionsContext.Provider
      value={{
        toggleStatus,
        loadingUpdate,
        toggleAutoPreven,
      }}
    >
      {children}
    </ClientesActionsContext.Provider>
  );
};

export const useClientesActions = () => useContext(ClientesActionsContext);
